/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { useSelector } from 'react-redux';
import { bool } from 'prop-types';
import mbpLogger from '@module-logger/mbp';

import { getFeatureFlag, getPresentationFamily } from '../../../../state/ducks/App/ducks/Config/Config-Selectors';
import { getBrand } from '../../../../state/ducks/App/ducks/Brand/Brand-Selectors';
import { getSSRDeviceType } from '../../../../state/ducks/App/App-Selectors';

import MobileGraphqlHeader from './MobileGraphqlHeader';

const MobileHeaderContainer = ({ isEyeBrowShow }) => {
    const ffWhichCheckoutVariation = useSelector(getFeatureFlag('which-checkout-variation'));
    const ffIsHideMobileHeaderOnScrollEnabled = useSelector(getFeatureFlag('is-hide-mobile-header-on-scroll-enabled'));
    const ffIsSearchUiInMobileMenuEnabled = useSelector(getFeatureFlag('is-search-ui-in-mobile-menu-enabled'));
    const isSearchUiV3Enabled = useSelector(getFeatureFlag('is-search-ui-v3-enabled'));

    const brand = useSelector(getBrand);
    const presentationFamily = useSelector(getPresentationFamily);
    const deviceType = useSelector(getSSRDeviceType);

    return (
        <MobileGraphqlHeader
            isEyeBrowShow={isEyeBrowShow}
            brand={brand}
            presentationFamily={presentationFamily}
            ffWhichCheckoutVariation={ffWhichCheckoutVariation}
            ffIsHideMobileHeaderOnScrollEnabled={ffIsHideMobileHeaderOnScrollEnabled}
            isSearchUiInMobileMenuEnabled={ffIsSearchUiInMobileMenuEnabled}
            deviceType={deviceType}
            isSearchUiV3Enabled={isSearchUiV3Enabled}
        />
    );
};

MobileHeaderContainer.propTypes = {
    isEyeBrowShow: bool.isRequired,
};

export default MobileHeaderContainer;
